import React, { createContext, useState, useContext, useEffect } from 'react';
import { MyContext } from './ProviderContext';
export const Home = () => {

    const { menuComponent, setMenuComponent } = useContext(MyContext);

    useEffect(() => {
        setMenuComponent({home:'active',about:'', services:'',team:'',contact:'',project:''});
    }, [])
    

    return (
        <>

            <div id="carousel" className="carousel slide" data-ride="carousel">
                <ol className="carousel-indicators">
                    <li data-target="#carousel" data-slide-to="0" className="active"></li>
                    <li data-target="#carousel" data-slide-to="1"></li>
                    <li data-target="#carousel" data-slide-to="2"></li>
                    <li data-target="#carousel" data-slide-to="3"></li>
                    <li data-target="#carousel" data-slide-to="4"></li>
                    <li data-target="#carousel" data-slide-to="5"></li>
                </ol>
                <div className="carousel-inner">

                    <div className="carousel-item active">
                        <img src="img/carousel-2.png" alt="Carousel Image" />
                        <div className="carousel-caption">
                            <p className="animated fadeInRight">We are professionals</p>
                            <h1 className="animated fadeInLeft">Your satisfaction is our concern</h1>
                          
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src="img/slide2.jpg" alt="Carousel Image" />
                        <div className="carousel-caption">
                            <p className="animated fadeInRight">We are your trusted partners</p>
                            <h1 className="animated fadeInLeft">In the delivery of exceptional services</h1>
                          
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src="img/slide3.jpg" alt="Carousel Image" />
                        <div className="carousel-caption">
                          
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src="img/slide4.jpg" alt="Carousel Image" />
                        <div className="carousel-caption">
                         
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src="img/carousel-1.png" alt="Carousel Image" />
                        <div className="carousel-caption">
                           
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img src="img/carousel-3.png" alt="Carousel Image" />
                        <div className="carousel-caption">
                      
                        </div>
                    </div>
                </div>

                <a className="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                </a>
                <a className="carousel-control-next" href="#carousel" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                </a>
            </div>

            <div className="feature wow fadeInUp" data-wow-delay="0.1s">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="flaticon-worker"></i>
                                </div>
                                <div className="feature-text">
                                    <h3>Our Vision</h3>
                                    <p>To be the go-to organization in Africa for EPC services</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="flaticon-building"></i>
                                </div>
                                <div className="feature-text">
                                    <h3>Our Mission</h3>
                                    <p> To apply best practices in executing all projects and operations, touching lives and exceeding the expectations of our clients and stakeholders</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <div className="feature-item">
                                <div className="feature-icon">
                                    <i className="flaticon-call"></i>
                                </div>
                                <div className="feature-text">
                                    <h3>Our commitment</h3>
                                    <p>We have a solid commitment to provide highest quality services through the most knowledge-based and cost effective methods available</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="about wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 col-md-6">
                            <div className="about-img">
                                <img src="img/about.jpg" alt="Image" />
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-6">
                            <div className="section-header text-left">
                                <p>Welcome to Frantino</p>
                                <h2>Multiple Years Of Positive Impact</h2>
                            </div>
                            <div className="about-text">
                                <p>
                                    Frantino Multiple Services Limited (FMSL) is an ISO 9001:2015 certified Company. A forward thinking multi-disciplinary indigenous company incorporated in Nigeria for the provision of broad-based Engineering, Procurement and Construction (EPC) Services.
                                </p>
                                <p>
                                    Incorporated in 2010, FRANTINO has provided satisfactory services to major clients like Nigerian Agip Oil Company Ltd, Indorama Petrochemicals, Seplat Energy Plc. etc. We have grown into a vastly integrated company, which has led to the formation of FRANTINO GROUP, with the incorporation of Frantino Construction Company Ltd, Frantino Petroleum Ltd, Frantino Steels Ltd, Frantino Farms Ltd and Frantino Petroleum Trading LLC in the U.A.E.
                                </p>
                                <a className="btn" href="/about">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="fact">
                <div className="container-fluid">
                    <div className="row counters">
                        <div className="col-md-6 fact-left wow slideInLeft">
                            <div className="row">
                                <div className="col-6">
                                    <div className="fact-icon">
                                        <i className="flaticon-worker"></i>
                                    </div>
                                    <div className="fact-text">
                                        <h2 data-toggle="counter-up">109</h2>
                                        <p>Professionals</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="fact-icon">
                                        <i className="flaticon-building"></i>
                                    </div>
                                    <div className="fact-text">
                                        <h2 data-toggle="counter-up">485</h2>
                                        <p>Satisfied Clients</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 fact-right wow slideInRight">
                            <div className="row">
                                <div className="col-6">
                                    <div className="fact-icon">
                                        <i className="flaticon-address"></i>
                                    </div>
                                    <div className="fact-text">
                                        <h2 data-toggle="counter-up">789</h2>
                                        <p>Completed Projects</p>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="fact-icon">
                                        <i className="flaticon-crane"></i>
                                    </div>
                                    <div className="fact-text">
                                        <h2 data-toggle="counter-up">890</h2>
                                        <p>Ongoing Projects</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Our Services</p>
                        <h2>We Provide Exceptional Services</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/service-1.jpg" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Our engineering team is made up of experience, certified and smart thinking engineers who has executed major projects across the globe.
                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3>Engineering Design</h3>
                                    <a className="btn" href="img/service-1.jpg" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/procurement.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            Our partnership with leading Original Equipment Manufacturers (OEMs) ensures we give you the highest quality of products and equipments tailored towards every project needs.
                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3>Strategic Procurement</h3>
                                    <a className="btn" href="img/procurement.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/construction.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>
                                            We provide professional client-focussed construction solutions. As an employee owned company, we go above and beyond on every project and deliver on our promises, with integrity.
                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3>Construction</h3>
                                    <a className="btn" href="img/construction.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/service-4.jpg" alt="Image" />
                                    <div className="service-overlay">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3 title="Road & Building Construction">Road & Building Construction</h3>
                                    <a className="btn" href="img/service-4.jpg" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/pipeline.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3 title="Pipeline/Flowline Construction, Sectional Replacement and Leak Repair/Maintenance Works">Pipeline/Flowline Construction, Sectional Replacement and Leak Repair/Maintenance Works</h3>
                                    <a className="btn" href="img/pipeline.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/surveillance.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3 title="Oil & Gas Facilities Surveillance and Security Solutions">Oil & Gas Facilities Surveillance and Security Solutions</h3>
                                    <a className="btn" href="img/surveillance.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>



                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/reclamation.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3 title="Dredging & Reclamation Works">Dredging & Reclamation Works</h3>
                                    <a className="btn" href="img/reclamation.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/fabrication.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3>Fabrication Works</h3>
                                    <a className="btn" href="img/fabrication.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
                            <div className="service-item">
                                <div className="service-img">
                                    <img src="img/structural-engineering.png" alt="Image" />
                                    <div className="service-overlay">
                                        <p>

                                        </p>
                                    </div>
                                </div>
                                <div className="service-text">
                                    <h3 title="Civil & Structural Engineering">Civil & Structural Engineering</h3>
                                    <a className="btn" href="img/structural-engineering.png" data-lightbox="service">+</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="video wow fadeIn" data-wow-delay="0.1s">
                <div className="container">
                    <button type="button" className="btn-play" data-toggle="modal" data-src="https://www.youtube.com/embed/DWRcNpR6Kdc" data-target="#videoModal">
                        <span></span>
                    </button>
                </div>
            </div>

            <div className="modal fade" id="videoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div className="embed-responsive embed-responsive-16by9">
                                <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" allow="autoplay"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="team">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Equipments</p>
                        <h2>High Value Equipments</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/mixer.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Concrete Mixer</h2>
                                </div>
                               
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/selfloadingtruck.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Selfloading Truck</h2>
                                    
                                </div>
                               
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/excavator.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Excavator</h2>
                                    
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/skid-steer-loader.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Skid Steer Loader</h2>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/payloader.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Pay Loader</h2>
                                </div>
                               
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/dredger.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Dredger</h2>
                                    
                                </div>
                               
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/generators.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>Power Generators</h2>
                                    
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
                            <div className="team-item">
                                <div className="team-img">
                                    <img src="img/mechanical-tool-box.png" alt="Team Image" />
                                </div>
                                <div className="team-text">
                                    <h2>mechanical Tool Box</h2>
                                    
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="blog">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Our Highly Esteemed</p>
                        <h2>Partners And Clients</h2>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 col-md-12 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="blog-item">
                                <div className="blog-img">
                                    <img src="img/partners.png" alt="Image" />
                                </div>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}